import PaidUsers from "./PaidUsers";
import AllUsers from "./AllUsers";
import ActiveUsers from "./ActiveUsers";
import { Stack } from "@mantine/core";
import { useEffect, useState } from "react";
import { getStatsAllUsers } from "../../../../../api/AdminAPI";
import GlobalEngagement from "./GlobalEngagement";
import { getLastXDaysStartAndEnd } from "../../../../../functions/dates";
import TotalBilling from "./TotalBilling";

function groupAndSumByWeeks(data) {
  const result = {};

  data.forEach((item) => {
    const date = new Date(item.date);
    const day = date.getDay();
    const diff = (day === 0 ? -6 : 1) - day;
    const monday = new Date(date);
    monday.setDate(date.getDate() + diff);

    const weekStart = monday.toISOString().split("T")[0];

    if (!result[weekStart]) {
      result[weekStart] = {
        date: weekStart,
        number_connections: 0,
        days: [],
      };
    }

    result[weekStart].number_connections += item.number_connections;
    result[weekStart].days.push(item);
  });

  return Object.values(result);
}

function groupAndSumByMonths(data) {
  const result = {};

  data.forEach((item) => {
    const date = new Date(item.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based

    const key = `${year}-${month}`; // e.g., "2025-06"

    if (!result[key]) {
      result[key] = {
        date: key,
        number_connections: 0,
        days: [],
      };
    }

    result[key].number_connections += item.number_connections;
    result[key].days.push(item);
  });

  return Object.values(result);
}

const UsersStats = ({ date_range, filter }) => {
  const [loading, setLoading] = useState(true);
  const [defaultStats, setDefaultStats] = useState({
    stats_current_range: {
      total_users: 0,
      active_users: 0,
      paid_users: 0,
    },
    stats_previous_range: {
      total_users: 0,
      active_users: 0,
      paid_users: 0,
    },
    connection_per_day: [],
  });
  const [stats, setStats] = useState({
    stats_current_range: {
      total_users: 0,
      active_users: 0,
      paid_users: 0,
    },
    stats_previous_range: {
      total_users: 0,
      active_users: 0,
      paid_users: 0,
    },
    connection_per_day: [],
  });

  useEffect(() => {
    if (!filter?.values?.find((x) => x.field_name === "any_datafield"))
      getStatsAllUsers({
        date_range: null,
        filter,
      })
        .then(async (response) => {
          setDefaultStats(response.data.statistics);
        })
        .finally(() => setLoading(false));
  }, [filter]);

  useEffect(() => {
    if (loading) {
      getStatsAllUsers({
        date_range: date_range.end_date
          ? date_range
          : getLastXDaysStartAndEnd(30),
        filter,
      })
        .then(async (response) => {
          let connection_per_day = response.data.statistics.connection_per_day;
          if (
            connection_per_day.length > 31 &&
            connection_per_day.length < 180
          ) {
            connection_per_day = groupAndSumByWeeks(connection_per_day);
          }
          if (connection_per_day.length >= 180) {
            connection_per_day = groupAndSumByMonths(connection_per_day);
          }
          setStats({
            ...response.data.statistics,
            connection_per_day: connection_per_day.reverse(),
          });
        })
        .finally(() => setLoading(false));
    }
  }, [loading]);

  useEffect(() => {
    if (
      date_range.start_date &&
      date_range.end_date
    ) {
      setLoading(true);
    }
    if (date_range.start_date && !date_range.end_date) {
      setLoading(false);
    }
    if (
      !date_range.start_date &&
      !date_range.end_date
    ) {
      setLoading(true);
    }
  }, [date_range]);

  return (
    <Stack mt={24}>
      <AllUsers
        loading={loading}
        stats={stats}
        defaultStats={defaultStats}
        date_range={date_range}
      />
      <ActiveUsers
        loading={loading}
        stats={stats}
        defaultStats={defaultStats}
        date_range={date_range}
      />
      <PaidUsers loading={loading} stats={stats} defaultStats={defaultStats} />
      <TotalBilling
        loading={loading}
        stats={stats}
        defaultStats={defaultStats}
      />
      <GlobalEngagement
        loading={loading}
        stats={stats}
        defaultStats={defaultStats}
      />
    </Stack>
  );
};

export default UsersStats;
